export const removeEmptyObject = (obj) => {
    if (typeof obj !== "undefined") {
        return Object.fromEntries(
            Object.entries(obj)
                .filter(([_, v]) => v || v == 0)
                .map(([k, v]) => [k, v === Object(v) ? removeEmptyObject(v) : v])
        );
    }
}

export const checkRole = (roles = [], allowedRoles = []) => {
    return !!roles?.role?.find(role => allowedRoles.includes(role)) ? true : false
}

export const getDownloadLinkTitle = (link, index) => {
    const title = (link?.title || '').trim()
    return title || `پارت ${index + 1}`
}

// export const queryStringToObject = url => Object.fromEntries([...new URLSearchParams(url.split('?')[1])])

// export const objectToQueryString = (queryParameters) => {
//     return queryParameters
//         ? Object.entries(queryParameters).reduce(
//             (queryString, [key, val], index) => {
//                 const symbol = queryString.length === 0 ? '?' : '&'
//                 queryString +=
//                     typeof val === 'string' ? `${symbol}${key}=${val}` : ''
//                 return queryString
//             },
//             ''
//         )
//         : ''
// }

export const nameConverter = name => {
    let result = ''

    switch (name) {
        case 'publishers':
            result = 'ناشران'
            break;
        case 'producers':
            result = 'تولید کنندگان'
            break;
        case 'publishDate':
            result = 'سال انتشار'
            break;
        case 'ages':
            result = 'رده بندی سنی'
            break;
        case 'categories':
            result = 'دسته بندی اصلی'
            break;
        case 'secondarySubjectCategoryId':
            result = 'دسته بندی ثانویه'
            break;

        default:
            break;
    }

    return result
}


export const getRandomKey = (length = 13) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
};
